export default "__VITE_ASSET__5e15ff8a__"